import {useApiQuery} from 'src/hooks/useApiQuery';
import type {TableConfig, ChartConfig, ApiWidgetType} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';


export type WidgetDetail = {
  id: string;
  widget_key: string;
  name: string;
  description: string | null;
  widget_type: ApiWidgetType;
  product_area: string | null;
  widget_icon: string | null;
  supported_filters: string[];
  supported_config: string[];
  table_config: TableConfig | null;
  chart_config: ChartConfig | null;
};

// Fetched lazily — only called when Preview/Edit panel opens
export function useWidgetDetail(widgetKey: string | null) {
  return useApiQuery<WidgetDetail>(
    widgetKey
      ? {pathname: `${BASE}/widgets/${encodeURIComponent(widgetKey)}`}
      : null,
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-widget-detail', widgetKey],
        enabled: Boolean(widgetKey),
        staleTime: 30 * 1000,
        gcTime: 60 * 1000,
      },
    },
  );
}
